/* eslint-disable @typescript-eslint/no-explicit-any */
import { deepCopy } from '../../helpers';

/**
 * Schema update from version 18 to version 19
 * - Adds blueprintOverrideBases field ({}) to all kitchens. Stores the generated content each
 *   blueprintOverrides entry was edited against so automation can flow through unedited segments
 *   while manual edits survive (3-way reconciliation in the blueprint view).
 */

export const u19 = (blueprint: any): any => {
	console.log('schema-update:process-update:19:started');

	try {
		const updatedBlueprint = deepCopy(blueprint);
		updatedBlueprint.schemaVersion = 19;

		if (updatedBlueprint.kitchens?.children) {
			updatedBlueprint.kitchens.children.forEach((kitchen: any) => {
				if (kitchen.blueprintOverrideBases === undefined) {
					kitchen.blueprintOverrideBases = {};
				}
			});
		}

		console.log('schema-update:process-update:19:completed');
		return updatedBlueprint;
	} catch (err) {
		console.error('schema-update:process-update:19:error', err);
		return null;
	}
};
